'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FieldRest = function () {
  function FieldRest($http) {
    (0, _classCallCheck3.default)(this, FieldRest);

    this.$http = $http;
    this.sprintf = require("sprintf-js").sprintf;

    this.PATH = {
      FIELDS_LIST: 'fields/',
      PIVOTS: 'fields/pivot_options/',
      FIELDS_DETAIL: 'fields/%1$s/',
      FIELDS_DETAIL_VALUES: 'fields/%1$s/values/'
    };
  }

  (0, _createClass3.default)(FieldRest, [{
    key: 'create',
    value: function create(postData) {
      return this.$http.post(this.PATH.FIELDS_LIST, postData);
    }
  }, {
    key: 'update',
    value: function update(id, postData) {
      return this.$http.patch(this.sprintf(this.PATH.FIELDS_DETAIL, id), postData);
    }
  }, {
    key: 'save',
    value: function save(postData) {
      return postData.id ? this.update(postData.id, postData) : this.create(postData);
    }
  }, {
    key: 'getList',
    value: function getList(params) {
      return this.$http.get(this.PATH.FIELDS_LIST, { params: params });
    }
  }, {
    key: 'getPivots',
    value: function getPivots(params) {
      return this.$http.get(this.PATH.PIVOTS, { params: params });
    }
  }, {
    key: 'read',
    value: function read(id) {
      return this.$http.get(this.sprintf(this.PATH.FIELDS_DETAIL, id));
    }
  }, {
    key: 'values',
    value: function values(id) {
      return this.$http.get(this.sprintf(this.PATH.FIELDS_DETAIL_VALUES, id));
    }
  }, {
    key: 'delete',
    value: function _delete(id) {
      return this.$http.delete(this.sprintf(this.PATH.FIELDS_DETAIL, id));
    }
  }, {
    key: 'findFieldByPath',
    value: function findFieldByPath(fields, id) {
      for (var i in fields) {
        var pk = fields[i].pk || '';
        if (pk == id) {
          return i;
        }
      }
      return -1;
    }
  }]);
  return FieldRest;
}();

exports.default = FieldRest;


//////////////////
// WEBPACK FOOTER
// ./src/api/FieldResource.js
// module id = 317
// module chunks = 0